const BaseModel = require('lib/base_model')

const Link = BaseModel.extend({

    defaults: {
        label: '',
        url: '',
        favicon_url: '',
    },

})

module.exports = Link
